export default __webpack_public_path__ + "static/media/mobile_reward1_detail_3Big.ad53fd72.png";